<template>
  <ModalMask @click="close">
    <Button icon @click="close" class="close-icon"><CloseIcon /></Button>
    <div class="light-box">
      <img
        v-if="handWriteImgPath || (isSP && slideImageId)"
        :src="imgPath"
        :class="[{ 'height-fixed': isSP, 'back-white': slideImgFreeHand }]"
      />
      <div v-else-if="slideImageId" class="image-base">
        <div class="arrow-block" @click="change(prevId)">
          <ArrowLargeIcon v-if="prevId" class="arrow prev" width="48" height="48" />
        </div>
        <img :src="slideImgPath" class="image-memo" />
        <div class="arrow-block" @click="change(nextId)">
          <ArrowLargeIcon v-if="nextId" class="arrow" width="48" height="48" />
        </div>
      </div>
      <div v-if="!handWriteImgPath" class="date-info">{{ dateTime }}</div>
    </div>
  </ModalMask>
</template>

<script>
import { mapState } from 'vuex'
import ModalMask from '@/components/molecules/ModalMask'
import CloseIcon from '@/components/icons/close'
import ArrowLargeIcon from '@/components/icons/arrowLarge'
import Button from '@/components/atoms/Button'

export default {
  name: 'Lightbox',
  components: {
    ModalMask,
    CloseIcon,
    ArrowLargeIcon,
    Button,
  },
  props: {
    /** 手書きメモ */
    handWriteImgPath: String,
    /** 画像メモ */
    slideImageId: Number,
  },
  computed: {
    ...mapState({
      imageMemos: 'imageMemos',
      isSP: state => state.app.isSP,
    }),
    imgPath() {
      return this.handWriteImgPath ? this.handWriteImgPath : this.slideImgPath
    },
    slideImgPath() {
      return this.imageMemos.byId[this.slideImageId].url
    },
    slideImgFreeHand() {
      const img = this.imageMemos.byId[this.slideImageId]

      return !((img && img.isFreeHand) === false)
    },
    dateTime() {
      return this.imageMemos.byId[this.slideImageId].datetime
    },
    nextId() {
      const next = this.imageMemos.allIds.indexOf(this.slideImageId) + 1
      if (this.imageMemos.allIds[next]) {
        return this.imageMemos.allIds[next]
      }
      return false
    },
    prevId() {
      const prev = this.imageMemos.allIds.indexOf(this.slideImageId) - 1
      if (this.imageMemos.allIds[prev]) {
        return this.imageMemos.allIds[prev]
      }
      return false
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    change(id) {
      this.$emit('select', id)
    },
  },
}
</script>

<style lang="postcss" scoped>
.light-box {
  max-width: calc(100vw - 32px);

  > img {
    max-width: 100%;

    &.height-fixed {
      max-height: 70vh;
    }

    &.back-white {
      background: var(--white);
    }
  }

  .responsive & {
    @media screen and (--sp-size) {
      max-height: 80vh;
      max-width: 100%;
    }
  }
}

.image-base {
  align-items: center;
  display: grid;
  grid-template-columns: 80px 1fr 80px;
  min-height: 80vh;
  width: 80vw;
}

.image-memo {
  background-color: var(--white);
  height: 80vh;
  object-fit: scale-down;
  width: 100%;

  &:focus {
    outline: 0;
  }
}

.arrow {
  fill: var(--white);

  &.prev {
    transform: rotate(180deg);
  }
}

.arrow-block {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 16px;
  width: 48px;
}

.date-info {
  color: var(--white);
  font-size: 13px;
  font-weight: bold;
  grid-area: 2 / 2;
  margin-top: 18px;
  text-align: center;
}

.close-icon {
  position: fixed;
  right: 8px;
  top: 8px;

  svg {
    fill: var(--white);
  }
}
</style>
